import { render, staticRenderFns } from "./obsModal.vue?vue&type=template&id=8749ba38&scoped=true"
import script from "./obsModal.vue?vue&type=script&lang=js"
export * from "./obsModal.vue?vue&type=script&lang=js"
import style0 from "./obsModal.vue?vue&type=style&index=0&id=8749ba38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8749ba38",
  null
  
)

export default component.exports